import React, { useState, useEffect, useCallback } from 'react';
import $ from 'jquery';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './analytics.css';

const FILTERS = [
  { key: 'thisWeek',  label: 'This Week' },
  { key: 'lastWeek',  label: 'Last Week' },
  { key: 'thisMonth', label: 'This Month' },
  { key: 'lastMonth', label: 'Last Month' },
];

function getRange(type) {
  const fmt = 'YYYY-MM-DDT00:00:00.000';
  switch (type) {
    case 'thisWeek':  return [moment().startOf('week').format(fmt), moment().format(fmt)];
    case 'lastWeek':  return [moment().subtract(1, 'weeks').startOf('week').format(fmt), moment().subtract(1, 'weeks').endOf('week').format(fmt)];
    case 'thisMonth': return [moment().startOf('month').format(fmt), moment().format(fmt)];
    case 'lastMonth': return [moment().subtract(1, 'month').startOf('month').format(fmt), moment().subtract(1, 'month').endOf('month').format(fmt)];
    default:          return [moment().format(fmt), moment().format(fmt)];
  }
}

export default function Analytics({ notifyError }) {
  const [dateSelection, setDateSelection] = useState([{
    startDate: new Date(),
    endDate:   new Date(),
    key:       'selection',
  }]);
  const [barChart,     setBarChart]     = useState([]);
  const [totalAccess,  setTotalAccess]  = useState(0);
  const [activeFilter, setActiveFilter] = useState('lastMonth');

  const fetchStats = useCallback((type, customRange) => {
    let url;
    if (type) {
      url = `/api/v1/connection/statistics?type=${type}`;
      const [start, end] = getRange(type);
      setDateSelection([{ startDate: new Date(start), endDate: new Date(end), key: 'selection' }]);
      setActiveFilter(type);
    } else {
      url = `/api/v1/connection/statistics?startDate=${customRange.startDate}&endDate=${customRange.endDate}`;
      setActiveFilter('');
    }
    $.ajax({
      method: 'GET', url,
      success(res) {
        setBarChart(res.response.accessList || []);
        setTotalAccess(res.response.totalAccess || 0);
      },
      error(err) {
        if (err.responseJSON && err.responseJSON.message) notifyError(err.responseJSON.message);
      }
    });
  }, [notifyError]);

  useEffect(() => { fetchStats('lastMonth'); }, []);

  const handleSelect = (ranges) => {
    setDateSelection([ranges.selection]);
    fetchStats(null, ranges.selection);
  };

  return (
    <div className="rs-analytics">

      {/* Header */}
      <div className="rs-analytics-header">
        <h2>Connections</h2>
        <div className="rs-analytics-filters">
          {FILTERS.map(f => (
            <button
              key={f.key}
              className={`rs-btn rs-analytics-filter-btn${activeFilter === f.key ? ' active' : ''}`}
              onClick={() => fetchStats(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats cards */}
      <div className="rs-analytics-stats">
        <div className="rs-analytics-stat">
          <span className="rs-analytics-stat-label">Unique accesses</span>
          <span className="rs-analytics-stat-value">{totalAccess}</span>
        </div>
      </div>

      {/* Body: calendar + chart */}
      <div className="rs-analytics-body">

        {/* Date picker */}
        <div className="rs-analytics-calendar">
          <DateRange
            showDateDisplay={false}
            editableDateInputs
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            ranges={dateSelection}
            rangeColors={['#1db954']}
          />
        </div>

        {/* Chart */}
        <div className="rs-analytics-chart">
          {barChart.length === 0
            ? <div className="rs-analytics-empty">No data for the selected period</div>
            : (
              <BarChart
                width={620}
                height={360}
                data={barChart}
                margin={{ top: 10, right: 20, left: 0, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
                <XAxis
                  dataKey="dateTime"
                  tickFormatter={t => moment(t).format('MMM D')}
                  stroke="var(--muted)"
                  tick={{ fill: 'var(--muted)', fontSize: 12 }}
                />
                <YAxis
                  stroke="var(--muted)"
                  tick={{ fill: 'var(--muted)', fontSize: 12 }}
                />
                <Tooltip
                  contentStyle={{
                    background: 'var(--card)',
                    border: '1px solid var(--border)',
                    color: 'var(--text)',
                    borderRadius: 8,
                    fontSize: 13,
                  }}
                />
                <Legend wrapperStyle={{ color: 'var(--muted)', fontSize: 13 }} />
                <Bar dataKey="connections" name="Connections" fill="#1db954" radius={[4, 4, 0, 0]} />
              </BarChart>
            )
          }
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/DashboardPage/ConnectionsAnalytics/analytics.js